<div *ngIf="object && (object.createdByManufacturer && isDealer || !object.createdByManufacturer && !isDealer)" class="current-object">
    <span class="label">{{ (object?.createdByManufacturer ? 'OFFER.HEADER.OBJEKT_NR_MANUFACTURER' : 'OFFER.HEADER.OBJEKT_NR_DEALER') | translate }}: </span>
    <span>{{object.objectNumber}}</span>
    <br>
    <span class="label">{{'OFFER.HEADER.OBJEKT' | translate }}:</span>
    <span>{{object.name}}</span>
</div>
<app-table-form [resourceType]="resourceType" [preselectedId]="objectId" (rowSelected)="onItemSelected($event)">
</app-table-form>
